import { AsyncPipe, CurrencyPipe, DatePipe, NgClass, SlicePipe } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { expandTdDivsAnimation, fadeInAnimation, onlyEnter } from '@zero/shared/ui-animations';
import { MoneyTransactionStatusPipe } from '@zero/shared/ui-pipes';
import { DividerComponent, ListToggleComponent } from '@zero/shared/ui-web-design-system';
import { CustomerStateFacade } from '@zero/shared/util-global-state';
import { MoneyTransaction } from '@zero/shared/util-models';
import { DataService } from '@zero/shared/util-web-app-services';
import { environment } from 'environments/environment';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'depot-money-transaction-overview',
  templateUrl: './money-transaction-overview.component.html',
  animations: [fadeInAnimation, expandTdDivsAnimation, onlyEnter],
  imports: [
    NgClass,
    SlicePipe,
    CurrencyPipe,
    DatePipe,
    MoneyTransactionStatusPipe,
    AsyncPipe,
    DividerComponent,
    ListToggleComponent,
    TranslocoPipe,
  ],
})
export class MoneyTransactionOverviewComponent implements OnInit {
  public showMe = true;
  public pageSize = 5;
  readonly #destroyRef = inject(DestroyRef);
  #sortDirection: 'asc' | 'desc' = 'desc';

  public readonly environment = environment;
  public readonly rootData = inject(DataService);
  public readonly customerStateFacade = inject(CustomerStateFacade);

  ngOnInit(): void {
    this.rootData.selectedCustomerChanged
      .pipe(
        filter((newCust) => !!newCust),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => {
        this.rootData.loadMoneyTransactions$(this.pageSize, this.#sortDirection);
        this.customerStateFacade.loadCustomerAccountData();
      });
  }

  public sortBy(sortAttr: string): void {
    if (this.#sortDirection === 'desc') {
      this.#sortDirection = 'asc';
    } else {
      this.#sortDirection = 'desc';
    }

    if (sortAttr === 'bookingDate') {
      this.rootData.loadMoneyTransactions$(this.pageSize, this.#sortDirection);
    }
  }

  // TODO: remove template call
  public showHighlighted(mt: MoneyTransaction): boolean {
    return !mt.matchedImportStorno && !mt.importMatchDate;
  }

  public getURI(mt: MoneyTransaction): string {
    return encodeURI(
      `${environment.apihost + environment.posteingangServiceUrl}/${this.rootData.getSelectedCustomer()}/mtx/${mt.id}/Umsatz-${mt.id}.pdf`,
    );
  }

  public deleteCachedDocuments(): void {
    this.rootData.deleteCachedDocuments();
  }

  // TODO: remove template call
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getSorterClasses(sorterLocation: 'before' | 'after', _: string): any {
    const sorterClasses = {};
    sorterClasses[`sorter-${sorterLocation}`] = true;
    sorterClasses[`sorter-${sorterLocation}--down`] = this.#sortDirection === 'desc';
    sorterClasses[`sorter-${sorterLocation}--active`] = true;
    return sorterClasses;
  }

  public more(): void {
    this.pageSize += 10;
    this.rootData.loadMoneyTransactions$(this.pageSize, this.#sortDirection);
  }
}
